// document.addEventListener('DOMContentLoaded', function() {
//   document.querySelector('.openForm').addEventListener('click', function() {
//     document.querySelector('.hulkForm').style.display = 'block';
//   })
//   document.querySelector('.closeForm .close').addEventListener('click', function() {
//     document.querySelector('.hulkForm').style.display = 'none';
//   })
// });

// document.addEventListener('DOMContentLoaded', function() {
//     const modal = document.querySelector('.hulkForm');
//     const modalContent = document.querySelector('.modal-content');
//     const openBtn = document.querySelector('.openForm');
//     const closeBtn = document.querySelector('.closeForm .close');
    
//     function openModal() {
//         modal.style.display = 'block';
//         document.body.style.overflow = 'hidden';
//     }
    
//     function closeModal() {
//         modal.style.display = 'none';
//         document.body.style.overflow = 'auto';
//     }
    
//     openBtn.addEventListener('click', openModal);
    
//     closeBtn.addEventListener('click', closeModal);
    
//     modal.addEventListener('click', function(e) {
//         if (e.target === modal) {
//             closeModal();
//         }
//     });
    
//     document.addEventListener('keydown', function(e) {
//         if (e.key === 'Escape' && modal.style.display === 'block') {
//             closeModal();
//         }
//     });
// });

document.addEventListener('DOMContentLoaded', function () {
    const modal = document.querySelector('.hulkForm');
    const modalContent = document.querySelector('.modal-content');
    const openBtns = document.querySelectorAll('.openForm');
    const closeBtns = document.querySelectorAll('.closeForm .close');

    function openModal() {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }

    function closeModal() {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
    }

    // Attach open event to all open buttons
    openBtns.forEach(btn => {
        btn.addEventListener('click', openModal);
    });

    // Attach close event to all close buttons
    closeBtns.forEach(btn => {
        btn.addEventListener('click', closeModal);
    });

    // Close modal when clicking outside the modal content
    modal.addEventListener('click', function (e) {
        if (e.target === modal) {
            closeModal();
        }
    });

    // Close modal with Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.style.display === 'block') {
            closeModal();
        }
    });
});

window.addEventListener('message', function(event) {
    if (event.data && event.data.type === "CLOSE_HULK_FORM") {
        console.log("Received CLOSE_HULK_FORM message");

        const modal = document.querySelector('.hulkForm');
        if (modal) {
            modal.style.display = 'none';
            document.body.style.overflow = 'auto';
        } else {
            console.warn("Modal .hulkForm not found");
        }
    }
});
